import { useContext, useEffect, useState, useCallback } from "react";
import { toast } from "react-hot-toast";
import { GlobalContext } from "../../../Context/GlobalContext";

/** tiny format helpers kept local */
const fmt = {
  dash: (v) => (v === null || v === undefined || v === "" ? "—" : v),
};

export default function useSuperAdmin() {
  const { api, api2, baseUrl, adminId, latitude, longitude } =
    useContext(GlobalContext);

  const [clients, setClients] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState({});

  const setSpin = (id, action) => setBusy((p) => ({ ...p, [id]: action }));
  const clearSpin = (id) => setBusy((p) => ({ ...p, [id]: null }));

  const getAllAdminUsers = async (adminId) => {
    try {
      const res = await api.post("/Admin/v1.0/getAllAdminUsers", {
        adminId: String(adminId),
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res.data.response) ? res.data.response : [],
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Failed to fetch admin users.",
          data: [],
        };
      }
    } catch (e) {
      console.error("getAllAdminUsers error:", e);
      return {
        success: false,
        message: "Failed to fetch admin users.",
        data: [],
      };
    }
  };
  const getAssignedClients = async (adminId) => {
    try {
      const res = await api.post("/Admin/v1.0/getAssignedClients", {
        adminId: String(adminId),
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res.data.response) ? res.data.response : [],
        };
      } else {
        return {
          success: false,
          message:
            res?.data?.responseMessage || "Failed to fetch assigned clients.",
          data: [],
        };
      }
    } catch (e) {
      console.error("getAssignedClients error:", e);
      return {
        success: false,
        message: "Failed to fetch assigned clients.",
        data: [],
      };
    }
  };
  const assignAdminUserToClient = async ({ adminId, users }) => {
    try {
      const res = await api.post("/Admin/v1.0/assignAdminUserToClient", {
        adminId: String(adminId),
        users,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message:
            res?.data?.responseMessage || "Clients assigned successfully.",
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Failed to assign clients.",
        };
      }
    } catch (e) {
      console.error("assignAdminUserToClient error:", e);
      return {
        success: false,
        message: "Failed to assign clients.",
      };
    }
  };
  const deleteAssignedClient = async (mappingId) => {
    try {
      const res = await api.post("/Admin/v1.0/deleteAssignedClient", {
        mappingId: String(mappingId),
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message:
            res?.data?.responseMessage || "Client unassigned successfully.",
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Failed to unassign client.",
        };
      }
    } catch (e) {
      console.error("deleteAssignedClient error:", e);
      return {
        success: false,
        message: "Failed to unassign client.",
      };
    }
  };
  const getSubscriptionPlan = async ({ adminId, userid }) => {
    try {
      const res = await api.post("/Admin/v1.0/getSubscriptionPlan", {
        adminId,
        userid,
      });

      if (
        res?.data?.responseCode === "00" &&
        Array.isArray(res.data.response)
      ) {
        return {
          success: true,
          data: res.data.response[0] || null,
        };
      } else {
        return {
          success: false,
          data: null,
        };
      }
    } catch (e) {
      console.error("getSubscriptionPlan error:", e);
      return {
        success: false,
        data: null,
      };
    }
  };
  const changeSubscriptionPlan = async ({ userid, planId }) => {
    try {
      const res = await api.post("/Admin/v1.0/changeSubscriptionPlan", {
        userid,
        planId,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message: res?.data?.responseMessage || "Subscription plan updated",
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Plan update failed",
        };
      }
    } catch (e) {
      console.error("changeSubscriptionPlan error:", e);
      return {
        success: false,
        message: "Change subscription API failed",
      };
    }
  };
  const getSuperAdminUserAllData = async () => {
    try {
      const res = await api.post("/Admin/getSuperAdminUserAllData", {});

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res.data.response) ? res.data.response : [],
        };
      }

      return {
        success: false,
        message: res?.data?.responseMessage || "Failed to fetch access menu.",
        data: [],
      };
    } catch (e) {
      console.error("getSuperAdminUserAllData error:", e);
      return {
        success: false,
        message: "Failed to fetch access menu.",
        data: [],
      };
    }
  };

const updateAdminRoleStatus = async ({ admin_id, requests }) => {
  try {
    const res = await api.post("/Admin/updateAdminRoleStatus", {
      admin_id: String(admin_id),
      requests,
    });

    const ok =
      res?.data?.responseCode === "00" ||
      res?.data?.status === "0" ||
      res?.data?.result?.[0]?.id === "Y";

    return {
      success: ok,
      message:
        res?.data?.responseMessage ||
        res?.data?.msg ||
        res?.data?.result?.[0]?.message ||
        "Access updated successfully.",
    };
  } catch (e) {
    console.error("updateAdminRoleStatus error:", e);
    return { success: false, message: "Failed to update access." };
  }
};

  const getRoleAdmin = async () => {
    try {
      const res = await api.post("/Admin/GetRoleAdmin", {});

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res.data.response) ? res.data.response : [],
        };
      }

      return {
        success: false,
        message: res?.data?.responseMessage || "Failed to fetch roles.",
        data: [],
      };
    } catch (e) {
      console.error("getRoleAdmin error:", e);
      return { success: false, message: "Failed to fetch roles.", data: [] };
    }
  };

  const updateRoleAdmin = async ({ adminId, roleId }) => {
    try {
      const res = await api.post("/Admin/updateRoleAdmin", {
        adminId: String(adminId),
        roleId: String(roleId),
      });

      return {
        success: res?.data?.responseCode === "00",
        message: res?.data?.responseMessage || "Role updated successfully.",
      };
    } catch (e) {
      console.error("updateRoleAdmin error:", e);
      return { success: false, message: "Failed to update role." };
    }
  };

  const updateAllAccess = async ({ adminId }) => {
    try {
      const res = await api.post("/Admin/updateAllAccess", {
        adminId: String(adminId),
      });

      return {
        success: res?.data?.responseCode === "00",
        message:
          res?.data?.responseMessage || "All access granted successfully.",
      };
    } catch (e) {
      console.error("updateAllAccess error:", e);
      return { success: false, message: "Failed to grant all access." };
    }
  };
  const getDataViaAdminID = async ({ admin_id }) => {
  try {
    const res = await api.post("/Admin/getDataViaAdminID", {
      admin_id: String(admin_id),
    });

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: Array.isArray(res.data.response) ? res.data.response : [],
        message: res?.data?.responseMessage || "Access fetched successfully.",
      };
    }

    return {
      success: false,
      data: [],
      message: res?.data?.responseMessage || "Failed to fetch admin access.",
    };
  } catch (e) {
    console.error("getDataViaAdminID error:", e);
    return {
      success: false,
      data: [],
      message: "Failed to fetch admin access.",
    };
  }
};
const insertAdminLogin = async ({
  admin_username,
  first_name,
  last_name,
  admin_loginid,
  admin_password,
  emp_ID,
  billing_name,
  role,
}) => {
  try {
    const res = await api.post("/Admin/insertAdminLogin",
      {
        admin_username,
        first_name,
        last_name,
        admin_loginid,
        admin_password,
        emp_ID,
        billing_name,
        role,
      },
      {
        headers: {
          accept: "*/*",
          "Content-Type": "application/json-patch+json",
        },
      }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage || "Admin created successfully.",
        data: res?.data?.response || null,
      };
    }

    return {
      success: false,
      message:
        res?.data?.responseMessage || "Failed to create admin.",
      data: null,
    };
  } catch (e) {
    console.error("insertAdminLogin error:", e);

    return {
      success: false,
      message:
        e?.response?.data?.responseMessage ||
        "Failed to create admin.",
      data: null,
    };
  }
};

const insertAdminRestaurantMapping = async ({ mappingList }) => {
  try {
    const res = await api.post(
      "/Admin/insertAdminRestaurantMapping",
      {
        mappingList,
      },
      {
        headers: {
          accept: "*/*",
          "Content-Type": "application/json-patch+json",
        },
      }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage ||
          "Restaurant mapping saved successfully.",
        data: res?.data?.response || null,
      };
    }

    return {
      success: false,
      message:
        res?.data?.responseMessage ||
        "Failed to save restaurant mapping.",
      data: null,
    };
  } catch (e) {
    console.error("insertAdminRestaurantMapping error:", e);

    return {
      success: false,
      message:
        e?.response?.data?.responseMessage ||
        "Failed to save restaurant mapping.",
      data: null,
    };
  }
};

const getAdminRestaurantMapping = async ({ fk_admin_id }) => {
  try {
    const res = await api.post(
      "/Admin/getAdminRestaurantUsers",
      {
        fk_admin_id: String(fk_admin_id),
      },
      {
        headers: {
          accept: "*/*",
          "Content-Type": "application/json-patch+json",
        },
      }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage ||
          "Restaurant mapping fetched successfully.",
        data: res?.data?.response || null,
      };
    }

    return {
      success: false,
      message:
        res?.data?.responseMessage ||
        "Failed to fetch restaurant mapping.",
      data: null,
    };
  } catch (e) {
    console.error("getAdminRestaurantMapping error:", e);

    return {
      success: false,
      message:
        e?.response?.data?.responseMessage ||
        e?.message ||
        "Failed to fetch restaurant mapping.",
      data: null,
    };
  }
};

return {
  clients,
  orders,
  loading,
  busy,
  getAllAdminUsers,
  getAssignedClients,
  assignAdminUserToClient,
  deleteAssignedClient,
  getSubscriptionPlan,
  changeSubscriptionPlan,
  getSuperAdminUserAllData,
  updateAdminRoleStatus,
  getRoleAdmin,
  updateRoleAdmin,
  updateAllAccess,
  getDataViaAdminID,
  insertAdminLogin,
  insertAdminRestaurantMapping,
  getAdminRestaurantMapping,
}
};
